import Vue from 'vue'
import _ from "lodash"

const components = import.meta.glob('../components/base/**/*.vue', { eager: true })


Object.keys(components).forEach(fileName => {
  const componentConfig = components[fileName]

  const componentName = _.upperFirst(
    _.camelCase(fileName.replace(/^\.\.\/components\/base\//, '').replace(/\.\w+$/, '')),
  )

  Vue.component(`Base${componentName}`, componentConfig.default || componentConfig)
})
